export default {
  CurrentAddress: {},
  Provider: {},
  ActiveAccountPolling: false,
};
